export default "__VITE_ASSET__CwKJVhqe__"